import React from "react"
import NavItem from "../NavItem"
import { Link } from "rebass"

const NavDropdown = ({ pathname, title, children }) => (
  <NavItem
    className="has-dropdown not-click"
    active={isActive(pathname, children)}
  >
    <Link color="gray">{title}</Link>
    <ul className="dropdown">{children}</ul>
  </NavItem>
)

const isActive = (pathname, children) => {
  let childRoutes = [].concat(children).map(x => x.props["pageName"])

  return childRoutes.indexOf(pathname) >= 0
}

export default NavDropdown



// WEBPACK FOOTER //
// ./src/components/NavDropdown/index.js